import styled from 'styled-components'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  ${Media.Phone`
    gap: 32px;
  `}
`

export const FontSelectContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;

  ${Media.Phone`
    flex-direction: column;
  `}
`

export const LineHeightContainer = styled.div``
